import Vue from 'vue'

import Currency from './models/currency'
import ErrorEntities from './models/error-entities'

export function isIslandHopping(): boolean {
  return process.env.VUE_APP_APPLICATION_NAME === 'med-experience'
}

export function companyName(): string {
  return process.env.VUE_APP_APPLICATION_NAME as string
}

export function humanizedCompanyName(): string {
  return isIslandHopping() ? 'Island Hopping' : 'Sail Croatia'
}

export function marketingSiteUrl(): string {
  return isIslandHopping()
    ? 'https://www.island-hopping.com/'
    : 'https://www.sail-croatia.com/'
}

export function capitalize(value: string): string {
  if (!value) {
    return ''
  }
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function humanize(str: string): string {
  return str.replace('_', ' ')
}

export function firstErrorMessage(errors: ErrorEntities): string {
  const errorKey = Object.keys(errors)[0]
  return `${capitalize(errorKey)}: ${errors[errorKey]}`
}

export function toCurrency(
  value: number,
  currency: Currency = process.env.VUE_APP_DEFAULT_CURRENCY as Currency,
  {
    prependCode,
    appendCode,
  }: { prependCode?: boolean; appendCode?: boolean } = {},
) {
  if (value !== 0 && !value) {
    return ''
  }

  value /= 100 // cents to pounds

  let result = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(value)

  if (prependCode) {
    result = `(${currency}) ${result}`
  }

  if (appendCode) {
    result = `${result} (${currency})`
  }

  return result
}

export function currencySymbol(
  currency: Currency = (process.env.VUE_APP_DEFAULT_CURRENCY as Currency) ||
    Currency.EUR,
) {
  switch (currency) {
    case Currency.EUR:
      return '€'
    case Currency.GBP:
      return '£'
    case Currency.USD:
      return '$'
    case Currency.AUD:
      return 'A$'
  }
}

Vue.mixin({
  computed: {
    isIslandHopping,
    humanizedCompanyName,
    companyName,
    marketingSiteUrl,
  },
})

declare module 'vue/types/vue' {
  interface Vue {
    isIslandHopping: boolean
    humanizedCompanyName: string
    companyName: string
    marketingSiteUrl: string
  }
}
